(function(){
  function init(root){
    if(root.dataset.altInitialized)return;
    root.dataset.altInitialized='1';
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-alt-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-alt-panel]'));
    function activateTab(index){
      tabs.forEach(function(tab,i){var active=i===index;tab.setAttribute('aria-selected',active?'true':'false');tab.tabIndex=active?0:-1;panels[i].hidden=!active;});
    }
    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){activateTab(index);});
      tab.addEventListener('keydown',function(event){
        var next=event.key==='ArrowRight'?(index+1)%tabs.length:event.key==='ArrowLeft'?(index+tabs.length-1)%tabs.length:event.key==='Home'?0:event.key==='End'?tabs.length-1:-1;
        if(next<0)return;event.preventDefault();activateTab(next);tabs[next].focus();
      });
    });
    var hero=root.querySelector('.alt-accessory__hero-image');
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('.alt-accessory__thumb'));
    function imageUrl(button){return window.matchMedia('(max-width: 899px)').matches?(button.dataset.preview||button.dataset.full):button.dataset.full;}
    function show(button){
      if(!button||!hero)return;
      hero.srcset='';
      hero.src=imageUrl(button);
      hero.alt=button.dataset.alt||'';
      thumbs.forEach(function(item){var active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false');});
    }
    thumbs.forEach(function(button){button.addEventListener('click',function(){show(button);});});
    function filterMedia(color){
      thumbs.forEach(function(button){button.hidden=!!color&&button.dataset.color.toLowerCase()!==color.toLowerCase();});
      var visible=thumbs.filter(function(button){return !button.hidden;});
      if(visible.length)show(visible[0]);
      var secondRow=root.querySelector('[data-alt-feature-row="2"]');
      if(secondRow)secondRow.hidden=visible.length<3;
      var firstRow=root.querySelector('.alt-accessory__feature-row');
      if(firstRow)firstRow.hidden=visible.length<2;
      [1,2].forEach(function(number){
        var image=root.querySelector('[data-alt-feature-img="'+number+'"]');
        var source=visible[number]||visible[visible.length-1];
        if(image&&source){image.src=imageUrl(source);image.alt=source.dataset.alt||'';}
      });
    }
    var variantsEl=root.querySelector('[data-alt-variants]');
    var selects=Array.prototype.slice.call(root.querySelectorAll('[data-alt-option]'));
    var swatchGroups=Array.prototype.slice.call(root.querySelectorAll('[data-alt-swatch-group]'));
    var initialSwatch=swatchGroups[0]&&swatchGroups[0].querySelector('[data-alt-swatch][aria-pressed="true"]');
    filterMedia(initialSwatch?initialSwatch.dataset.value:null);
    var preloadedImages=[];
    function preloadColors(){
      var seen={};
      thumbs.forEach(function(button){
        var color=button.dataset.color;
        if(!color||seen[color])return;
        seen[color]=true;
        var image=new Image();image.src=imageUrl(button);preloadedImages.push(image);
      });
    }
    if(window.requestIdleCallback)window.requestIdleCallback(preloadColors,{timeout:1800});else setTimeout(preloadColors,500);
    if(!variantsEl||(!selects.length&&!swatchGroups.length))return;
    var variants=[];try{variants=JSON.parse(variantsEl.textContent);}catch(e){return;}
    function sync(){
      var values=[];
      selects.forEach(function(select){values[Number(select.dataset.altOption)]=select.value;});
      swatchGroups.forEach(function(group){var selected=group.querySelector('[data-alt-swatch][aria-pressed="true"]');if(selected)values[Number(group.dataset.altOptionIndex)]=selected.dataset.value;});
      var variant=variants.find(function(item){return values.every(function(value,index){return item.options[index]===value;});});
      if(!variant)return;
      root.querySelector('[data-alt-variant-id]').value=variant.id;
      var add=root.querySelector('[data-alt-add]');add.disabled=!variant.available;add.textContent=variant.available?(root.dataset.altAddLabel||'In den Warenkorb'):root.classList.contains('alt-accessory--leather-tag')?(root.dataset.altComingSoonLabel||'Bald verfügbar'):(root.dataset.altUnavailableLabel||'Nicht verfügbar');
      var price=root.querySelector('[data-alt-price]');if(price&&window.Shopify&&typeof window.Shopify.formatMoney==='function')price.innerHTML=window.Shopify.formatMoney(variant.price,window.Shopify.money_format);
      if(window.history&&window.history.replaceState){var url=new URL(location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);}
    }
    selects.forEach(function(select){select.addEventListener('change',sync);});
    swatchGroups.forEach(function(group){
      group.querySelectorAll('[data-alt-swatch]').forEach(function(button){
        button.addEventListener('click',function(){
          group.querySelectorAll('[data-alt-swatch]').forEach(function(item){item.setAttribute('aria-pressed',item===button?'true':'false');});
          group.querySelector('[data-alt-selected-label]').textContent=button.dataset.value;
          filterMedia(button.dataset.value);
          sync();
        });
      });
    });
  }
  function boot(){document.querySelectorAll('[data-alt-accessory]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
